/* eslint-disable no-undef */
const mapStyle = [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          weight: '2.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#9c9c9c',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#eeeeee',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7b7b7b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#46bcec',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c8d7d4',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#070707',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
  ];

const selectors = {
    map: '[data-js-map]',
    infoWindows: '[data-info-window]',
    searchStores: '[data-search-stores]',
    selectState: '[data-filter-stores]',
    noStoresMessage: '[data-no-stores-message]',
    searchStatus: '[data-search-status]',
    suggestions: '[data-search-suggestions]',
};

/**
 * How long the permission bubble gets before a fallback location is shown, in ms.
 *
 * Not a timeout on the device request — that is left running indefinitely. This only bounds how
 * long the page sits doing nothing while an unanswered bubble hangs, which is what made the
 * locator look broken for anyone who ignored it.
 */
const PROMPT_GRACE = 4000;

  const classes = {
    activeInfoWindow: 'DG-info-window--active',
    activeNoStoresMessage: 'DG-no-stores-message--active',
};

const australianStates = {
  NSW: { name: 'New South Wales', lat: -33.8688, lng: 151.2093 },
  VIC: { name: 'Victoria', lat: -37.8136, lng: 144.9631 },
  QLD: { name: 'Queensland', lat: -27.4698, lng: 153.0251 },
  WA: { name: 'Western Australia', lat: -31.9505, lng: 115.8605 },
  SA: { name: 'South Australia', lat: -34.9285, lng: 138.6007 },
  TAS: { name: 'Tasmania', lat: -42.8821, lng: 147.3272 },
  ACT: { name: 'Australian Capital Territory', lat: -35.2809, lng: 149.1300 },
  NT: { name: 'Northern Territory', lat: -12.4634, lng: 130.8456 }
};

  function parseCoordinates(coordinates) {
    if (!coordinates || typeof coordinates !== 'string') return;

    const parts = coordinates.split(',');

    const latitude = parseFloat(parts[0]);
    const longitude = parseFloat(parts[1]);

    if (isNaN(latitude) || isNaN(longitude)) {
      window.console.error('Invalid latitude or longitude');
      return null;
    }

    return {latitude, longitude};
  }

  function filterInfoWindowsByState(infoWindows, stateCode) {
    let availableStoresCount = 0;
    const noStoresMessage = document.querySelector(selectors.noStoresMessage);
    infoWindows.forEach((infoWindow) => {
      if (stateCode === 'All' || infoWindow.dataset?.state === stateCode) {
        infoWindow.classList.add(classes.activeInfoWindow);
        availableStoresCount++;
      } else {
        infoWindow.classList.remove(classes.activeInfoWindow);
      }
    });

    if (availableStoresCount === 0 && noStoresMessage) {
      noStoresMessage.classList.add(classes.activeNoStoresMessage);
    } else {
      noStoresMessage.classList.remove(classes.activeNoStoresMessage);
    }
  }

  function getVisibleMarkerIds(infoWindows, stateCode) {
    const ids = [];
    infoWindows.forEach((iw) => {
      if (stateCode === 'All' || iw.dataset?.state === stateCode) {
        ids.push(iw.dataset.id);
      }
    });
    return ids;
  }

  function moveMapToState(stateCode, map, infoWindows, markers) {
    filterInfoWindowsByState(infoWindows, stateCode);

    if (stateCode === 'All') {
      map.setCenter({ lat: -25.2744, lng: 133.7751 });
      map.setZoom(4);
      return;
    }

    const visibleIds = getVisibleMarkerIds(infoWindows, stateCode);
    const stateMarkers = markers.filter(m => visibleIds.includes(m.id));

    if (stateMarkers.length === 1) {
      map.setCenter(stateMarkers[0].getPosition());
      map.setZoom(10);
    } else if (stateMarkers.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      stateMarkers.forEach(m => bounds.extend(m.getPosition()));
      map.fitBounds(bounds, 50);
    } else {
      const state = australianStates[stateCode];
      if (state) {
        map.setCenter({ lat: state.lat, lng: state.lng });
        map.setZoom(6);
      }
    }
  }

  const initFilters = (map, infoWindows, markers) => {
    const searchStores = document.querySelector(selectors.searchStores);
    const selectState = document.querySelector(selectors.selectState);
    if(!searchStores && !selectState) return;

    selectState.addEventListener('change', (e) => {
      const stateCode = e.target.value;
      moveMapToState(stateCode, map, infoWindows, markers);
    });

    searchStores.addEventListener('keyup', (e) => {
      const searchValue = e.target.value.toLowerCase();
      let availableStoresCount = 0;
      const noStoresMessage = document.querySelector(selectors.noStoresMessage);

      infoWindows.forEach((infoWindow) => {
        const storeId = infoWindow.dataset.id.toLowerCase();
        const storeAddress = infoWindow.dataset.address.toLowerCase();
        if (storeId.includes(searchValue) || storeAddress.includes(searchValue)) {
          infoWindow.classList.add(classes.activeInfoWindow);
          availableStoresCount++;
        } else {
          infoWindow.classList.remove(classes.activeInfoWindow);
        }
      });

      if (availableStoresCount === 0) {
        noStoresMessage.classList.add(classes.activeNoStoresMessage);
      } else {
        noStoresMessage.classList.remove(classes.activeNoStoresMessage);
      }
    });
  }

  const initMap = (mapElement, markers) => {
    if(!mapElement) return;
    const desktopQuery = window.matchMedia(`(min-width: 1000px)`);
    const markersData = mapElement.dataset.markers;
    const mapSettings = mapElement.dataset.settings;
    const infoWindows = document.querySelectorAll(selectors.infoWindows);

    if (!markersData || !mapSettings) return;

    const markersJson = JSON.parse(markersData);
    const mapSettingsJson = JSON.parse(mapSettings);
    const customMapMarkerIcon = mapElement.dataset?.markerImageUrl;

    const coordinates = {
      desktop: parseCoordinates(mapSettingsJson?.map_start_position),
      mobile: parseCoordinates(mapSettingsJson?.map_start_position_mobile),
    };

    const zoom = {
      desktop: mapSettingsJson?.map_zoom || 11,
      mobile: mapSettingsJson?.map_zoom_mobile || 11,
    };

    const view = desktopQuery.matches ? 'desktop' : 'mobile';
    const longitude = coordinates[view]?.longitude;
    const latitude = coordinates[view]?.latitude;

    const mapOptions = {
      zoom: zoom[view],
      center: new google.maps.LatLng(latitude, longitude),
      styles: mapStyle,
      streetViewControl: false,
    };

    let map = new google.maps.Map(mapElement, mapOptions);

    markersJson.forEach(function (markerData) {
      const coordinates = markerData.coordinates.split(',');
      const latLng = new google.maps.LatLng(parseFloat(coordinates[0]), parseFloat(coordinates[1]));

      const customMarkerIcon = {
        url: customMapMarkerIcon ?? null,
        scaledSize: new google.maps.Size(50, 50),
      };

      const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: markerData.title,
        icon: customMarkerIcon ?? null,
      });

      marker.id = markerData.id;
      marker.stateCode = markerData.state;
      markers.push(marker);

      marker.addListener('click', function () {
        infoWindows.forEach((infoWindow) => {
          if (marker.id === infoWindow.dataset.id) {
            infoWindow.classList.add(classes.activeInfoWindow);
          } else {
            infoWindow.classList.remove(classes.activeInfoWindow);
          }
        });
      });
    });

    return map;
  }

/**
 * DG CUSTOM (#45): builds the compact record the shared cache stores, from an info window.
 *
 * The marker JSON carries coordinates but not the phone number or store URL, and those are what
 * the PDP sold-out note (#15) needs in order to tell someone who to ring. Both already exist in
 * the rendered card, so they are read back out of the DOM rather than duplicated into the JSON
 * payload — this page already ships 52 stores twice over.
 * @param {Element} infoWindow - The store's card.
 * @param {string} coordinates - The store's "lat,lng" from the marker data.
 * @returns {object|null}
 */
function buildStoreRecord(infoWindow, coordinates) {
  if (!infoWindow) return null;

  const title = infoWindow.querySelector('.DG-info-window__header .h5');
  const phone = infoWindow.querySelector('a[href^="tel:"]');
  const details = infoWindow.querySelector('.DG-store-details-btn');

  // Same shape as the note's own store objects: t/p/c/u. A store with no phone is no use to the
  // note, which exists purely to say who to call, so it is not worth caching.
  if (!title || !phone) return null;

  return {
    t: title.textContent.trim(),
    p: phone.textContent.trim(),
    c: coordinates,
    u: details ? details.getAttribute('href') : null
  };
}

/**
 * DG CUSTOM (#45): reorders the store list nearest-first and labels each card with its distance.
 *
 * Reorders the existing nodes rather than re-rendering: the state dropdown and the text search
 * both work by toggling a class on these same elements, so moving them keeps every filter
 * working untouched. The "no stores" message is left where it is as the container's first child.
 * @param {Array<{store: object, km: number}>} ranked - Stores, nearest first.
 * @param {NodeList} infoWindows - All store cards.
 */
function sortInfoWindowsByDistance(ranked, infoWindows) {
  const byId = {};
  infoWindows.forEach((infoWindow) => { byId[infoWindow.dataset.id] = infoWindow; });

  const container = infoWindows[0] ? infoWindows[0].parentElement : null;
  if (!container) return;

  ranked.forEach(({ store, km }) => {
    const infoWindow = byId[store.id];
    if (!infoWindow) return;

    const header = infoWindow.querySelector('.DG-info-window__header');
    if (!header) return;

    // Reused across searches, never created-once. This runs again on every address search, and an
    // earlier version only inserted the label when absent — so searching Perth and then Sydney
    // reordered the list correctly but left every card showing its distance from Perth.
    let distance = header.querySelector('.DG-info-window__distance');

    if (!distance) {
      distance = document.createElement('p');
      distance.className = 'DG-info-window__distance';

      // Sits directly under the address, not appended to the end of the header — the header also
      // holds the "Get directions" row, and appending pushed the distance below it, splitting the
      // two bits of location information with an action.
      header.insertBefore(distance, header.querySelector('.DG-store-info-item') || null);
    }

    // Under 10km reads better with a decimal; past that it is noise.
    distance.textContent = `${km < 10 ? km.toFixed(1) : Math.round(km)} km away`;

    container.appendChild(infoWindow);
  });
}

/**
 * DG CUSTOM (#45): resolves the shopper's position and puts their nearest store first.
 *
 * Restricted to a precise fix. The locator states a single nearest store, and an IP guess is only
 * city-accurate at best — it has put a Brisbane shopper in South Australia. On a page that already
 * lists all 52 stores with a working search, no ranking beats a confidently wrong one.
 *
 * Everything here is additive: if position never resolves, the list stays alphabetical and the map
 * keeps its configured start position, exactly as before.
 * @param {object} map - The Google map instance.
 * @param {NodeList} infoWindows - All store cards.
 * @param {Array} markers - The map markers.
 * @param {Element} mapElement - The map container, which carries the marker JSON and the API key.
 */
const initNearestStore = async (map, infoWindows, markers, mapElement, mapState) => {
  if (!map || !mapElement || !window.DGStoreLocate) return;

  let markersJson = [];

  try {
    markersJson = JSON.parse(mapElement.dataset.markers || '[]');
  } catch (e) {
    return;
  }

  // What we last put in the search box, so an upgrade can replace our own suggestion while still
  // leaving anything the shopper typed alone.
  let suggested = null;

  /**
   * Puts the shopper's place name in the search box, so an estimate is visible and correctable
   * rather than silently driving the ranking.
   * @param {object} position - A resolved position, which may already carry its name.
   */
  const showPlaceName = async (position) => {
    const input = document.querySelector(selectors.searchStores);

    // Never overwrite what they have typed — theirs is the better answer by definition.
    if (!input || (input.value && input.value !== suggested)) return;

    const city = position.city
      || await DGStoreLocate.reverseGeocode(position, mapElement.dataset.geoKey);

    if (!city) return;

    suggested = city;

    // Value only. Dispatching an event here would run the theme's keyup filter and narrow the
    // list to stores whose name or address contains the text, instead of leaving it ranked.
    input.value = city;

    // Text we put there is a suggestion, so the first click should let them type straight over it
    // instead of appending to a word they did not write. One-shot: once they have taken control
    // of the box, it behaves like any other input.
    input.addEventListener('focus', function selectSuggestion() {
      input.removeEventListener('focus', selectSuggestion);
      input.select();
    });

    // Written back so naming this position is billed once per browser, not once per visit.
    DGStoreLocate.writePosition({ ...position, city }, position.src);
  };

  const applyPosition = (position, cacheStore) => {
    const ranked = DGStoreLocate.byDistance(markersJson, position, (store) => store.coordinates);
    if (!ranked.length) return false;

    sortInfoWindowsByDistance(ranked, infoWindows);

    const nearest = ranked[0];
    const nearestMarker = markers.find((marker) => marker.id === nearest.store.id);

    if (nearestMarker) {
      // Muted until the map settles, so this move does not re-measure every distance from the
      // store we just centred on instead of from where the shopper actually is.
      mapState.suppressResort = true;
      map.setCenter(nearestMarker.getPosition());
      map.setZoom(10);
      google.maps.event.addListenerOnce(map, 'idle', () => { mapState.suppressResort = false; });
    }

    // Hand the result to the PDP note (#15), so a product page stops guessing once the locator
    // has a precise answer. Only ever from a precise one: the note names a store to ring with no
    // search box next to it, so an estimate there is a wrong phone number with no way back.
    if (cacheStore) {
      const record = buildStoreRecord(
        document.querySelector(`[data-info-window][data-id="${nearest.store.id}"]`),
        nearest.store.coordinates
      );

      if (record) DGStoreLocate.writeCache(record, position.src);
    }

    return true;
  };

  /**
   * Applies a precise fix, superseding any estimate already on screen.
   * @param {object} position - A precise position.
   */
  const usePrecise = async (position) => {
    if (!position || !applyPosition(position, true)) return false;

    await showPlaceName(position);
    return true;
  };

  const locate = async () => {
    // Started, not awaited. The device request is left running for as long as it takes, because
    // the permission bubble is the shopper's to answer and putting a clock on it would read a
    // slow decision as a refusal.
    const device = DGStoreLocate.resolvePosition(null, { approximate: false });

    // But waiting on an answer that may never come is what left this page blank: an unanswered
    // bubble leaves the request pending forever. So the wait is bounded, and what is bounded is
    // only how long we wait before showing a fallback — never the device request itself.
    const answered = await Promise.race([
      device,
      new Promise((resolve) => { setTimeout(() => resolve(undefined), PROMPT_GRACE); })
    ]);

    if (answered !== undefined && await usePrecise(answered)) return;

    // Nothing precise yet. Show the estimate: the place name goes in the search box, where the
    // shopper can see what was assumed and type over it, and it is never handed to the PDP note.
    //
    // skipDevice because the request above is still in flight or already done; asking again
    // would risk a second permission prompt for an answer we are already waiting on.
    const estimate = await DGStoreLocate.resolvePosition(
      mapElement.dataset.geoKey,
      { skipDevice: true, allowWhilePrompting: true }
    );

    if (estimate) {
      applyPosition(estimate, false);
      await showPlaceName(estimate);
    }

    // A shopper who takes their time and then allows still gets the exact answer — it replaces
    // the estimate rather than being thrown away for arriving late.
    device.then(usePrecise);
  };

  await locate();
};

/**
 * DG CUSTOM (#45): shows every store again and clears the "No stores found" message.
 *
 * A store network's locator should always be able to answer "which one is nearest" — the state
 * dropdown always lands on stores, and the search box should not be the one control that strands
 * someone. Order is left alone: whatever ranking is already applied stays until the geocode
 * returns a better one.
 * @param {NodeList} infoWindows - All store cards.
 */
function revealAllStores(infoWindows) {
  infoWindows.forEach((infoWindow) => infoWindow.classList.add(classes.activeInfoWindow));

  const noStoresMessage = document.querySelector(selectors.noStoresMessage);
  if (noStoresMessage) noStoresMessage.classList.remove(classes.activeNoStoresMessage);
}

/**
 * DG CUSTOM (#45): shows or hides the "finding your nearest stores" line.
 *
 * The gap between typing and a ranked list is a network round-trip, and an unlabelled gap reads
 * as "nothing found" — which is what Rom saw. Naming it as work in progress costs one line.
 * @param {boolean} searching - Whether a geocode is currently in flight.
 */
function setSearchStatus(searching) {
  const status = document.querySelector(selectors.searchStatus);
  if (status) status.hidden = !searching;

  // Belt and braces: "No stores found" must never be on screen while we are still looking. The
  // theme's own filter sets it from its keyup listener, which runs before ours.
  if (searching) {
    const noStoresMessage = document.querySelector(selectors.noStoresMessage);
    if (noStoresMessage) noStoresMessage.classList.remove(classes.activeNoStoresMessage);
  }
}

/**
 * DG CUSTOM (#45): "type a suburb or postcode, get the nearest stores".
 *
 * Layered ON TOP of the existing name/address filter rather than replacing it: typing still
 * narrows the list instantly and for free, exactly as before. Pressing Enter is the new part —
 * it geocodes whatever was typed and re-orders every store by distance from that place, which is
 * what someone typing "3000" or "Bondi" actually wants and what the old filter could never do.
 *
 * Bound to Enter, NOT to keystrokes, because each submit is a billable geocode. Typing "Melbourne"
 * on keyup would have been nine of them.
 * @param {object} map - The Google map instance.
 * @param {NodeList} infoWindows - All store cards.
 * @param {Array} markers - The map markers.
 * @param {Element} mapElement - The map container, which carries the marker JSON and the API key.
 */
const initAddressSearch = (map, infoWindows, markers, mapElement, mapState) => {
  const input = document.querySelector(selectors.searchStores);
  if (!input || !map || !mapElement || !window.DGStoreLocate) return;

  let markersJson = [];

  try {
    markersJson = JSON.parse(mapElement.dataset.markers || '[]');
  } catch (e) {
    return;
  }

  // Remembers the last place we resolved, so pressing Enter again — or a debounce firing after a
  // search that already ran — cannot bill a second time for an identical query.
  let lastQuery = null;
  let lastPosition = null;
  let debounce = null;

  // Last suggestion list rendered, and the query it belongs to. Reused so resolving a place does
  // not ask for suggestions the dropdown already has.
  let suggestions = [];
  let suggestedFor = null;

  const applyPosition = (position) => {
    const ranked = DGStoreLocate.byDistance(markersJson, position, (store) => store.coordinates);
    if (!ranked.length) return;

    // A typed place beats an IP guess: the shopper has told us, in their own words, which part of
    // the country they care about. Saving it means the PDP note stops guessing too, and gives them
    // the only direct control they have over what it says.
    //
    // Judgement call worth knowing about: someone searching a city they are merely curious about
    // will move their note there. Searching again is the undo, and it is still better than an IP
    // guess they cannot influence at all.
    DGStoreLocate.writePosition(position, 'address');

    const record = buildStoreRecord(
      document.querySelector(`[data-info-window][data-id="${ranked[0].store.id}"]`),
      ranked[0].store.coordinates
    );

    if (record) DGStoreLocate.writeCache(record, 'address');

    // The keyup filter has almost certainly hidden most stores by now, and a distance ranking of
    // three surviving name matches is meaningless. Reveal everything, and put the state dropdown
    // back to All so the controls do not contradict what is on screen.
    const selectState = document.querySelector(selectors.selectState);
    if (selectState) selectState.value = 'All';
    filterInfoWindowsByState(infoWindows, 'All');

    sortInfoWindowsByDistance(ranked, infoWindows);

    const nearestMarker = markers.find((marker) => marker.id === ranked[0].store.id);
    if (nearestMarker) {
      // Muted until the map settles, so this move does not re-measure every distance from the
      // store we just centred on instead of from where the shopper actually is.
      mapState.suppressResort = true;
      map.setCenter(nearestMarker.getPosition());
      map.setZoom(10);
      google.maps.event.addListenerOnce(map, 'idle', () => { mapState.suppressResort = false; });
    }
  };

  const runAddressSearch = async (rawQuery) => {
    const query = rawQuery.trim();
    if (!query) { setSearchStatus(false); return; }

    let position = null;

    if (query.toLowerCase() === lastQuery) {
      position = lastPosition;
    } else {
      // The dropdown has usually already asked for these, so spend the Details call only.
      const known = (suggestedFor === query.toLowerCase() && suggestions.length)
        ? suggestions[0].id
        : null;

      position = known
        ? await DGStoreLocate.placeLocation(known, mapElement.dataset.geoKey)
        : await DGStoreLocate.geocodeAddress(query, mapElement.dataset.geoKey);

      lastQuery = query.toLowerCase();
      lastPosition = position;
    }

    setSearchStatus(false);

    // Not a place we could resolve. The full list is already back on screen from the keyup
    // handler, ordered by whatever we last knew, so the shopper still has every store and a
    // sensible ranking — never a dead end.
    if (position) applyPosition(position);
  };

  let lastHandled = null;

  // ---- Type-ahead dropdown -------------------------------------------------------------------

  const list = document.querySelector(selectors.suggestions);
  let active = -1;
  let suggestDebounce = null;

  // Query the shopper closed the list on. Keyup fires after Escape and would otherwise reopen it.
  let dismissedFor = null;

  const closeSuggestions = () => {
    if (!list) return;
    list.hidden = true;
    list.textContent = '';
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  };

  const setActive = (index) => {
    if (!list) return;
    const items = list.children;
    if (!items.length) return;

    active = (index + items.length) % items.length;

    for (let i = 0; i < items.length; i += 1) {
      const isActive = i === active;
      items[i].classList.toggle('DG-store-suggestions__item--active', isActive);
      items[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    input.setAttribute('aria-activedescendant', items[active].id);
    items[active].scrollIntoView({ block: 'nearest' });
  };

  // Picking a suggestion is the one place a Details call is unambiguously wanted, so it skips the
  // debounce and the name-match gate entirely.
  const pickSuggestion = async (suggestion) => {
    input.value = suggestion.text;
    lastHandled = suggestion.text;
    closeSuggestions();
    clearTimeout(debounce);
    clearTimeout(suggestDebounce);
    revealAllStores(infoWindows);
    setSearchStatus(true);

    const position = await DGStoreLocate.placeLocation(suggestion.id, mapElement.dataset.geoKey);

    lastQuery = suggestion.text.toLowerCase();
    lastPosition = position;
    setSearchStatus(false);

    if (position) applyPosition(position);
  };

  const renderSuggestions = (results, query) => {
    if (!list) return;

    suggestions = results;
    suggestedFor = query.toLowerCase();
    list.textContent = '';
    active = -1;
    input.removeAttribute('aria-activedescendant');

    if (!results.length || input.value.trim() !== query) {
      closeSuggestions();
      return;
    }

    results.forEach((suggestion, index) => {
      const item = document.createElement('li');
      item.className = 'DG-store-suggestions__item';
      item.id = `DG-store-suggestion-${index}`;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'false');

      const main = document.createElement('span');
      main.className = 'DG-store-suggestions__main';
      main.textContent = suggestion.main || suggestion.text;
      item.appendChild(main);

      if (suggestion.secondary) {
        const secondary = document.createElement('span');
        secondary.className = 'DG-store-suggestions__secondary';
        secondary.textContent = suggestion.secondary;
        item.appendChild(secondary);
      }

      // mousedown, not click: blur fires first on a click and would close the list underneath it.
      item.addEventListener('mousedown', (event) => {
        event.preventDefault();
        pickSuggestion(suggestion);
      });

      list.appendChild(item);
    });

    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const requestSuggestions = (query) => {
    clearTimeout(suggestDebounce);

    if (query.length < 3) { closeSuggestions(); return; }
    if (dismissedFor === query.toLowerCase()) return;

    // Arrow keys fire keyup too, and re-rendering an already-open list would wipe the highlight
    // the shopper just moved.
    if (suggestedFor === query.toLowerCase()) {
      if (!list || list.hidden || !list.children.length) renderSuggestions(suggestions, query);
      return;
    }

    suggestDebounce = setTimeout(async () => {
      renderSuggestions(await DGStoreLocate.suggestPlaces(query, mapElement.dataset.geoKey), query);
    }, 250);
  };

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('autocomplete', 'off');
  if (list) input.setAttribute('aria-controls', list.id);

  input.addEventListener('blur', () => { setTimeout(closeSuggestions, 100); });

  // Enter is the explicit trigger; with the dropdown open it means "this one".
  input.addEventListener('keydown', (event) => {
    const open = list && !list.hidden && list.children.length;

    if (open && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      setActive(active + (event.key === 'ArrowDown' ? 1 : -1));
      return;
    }

    if (event.key === 'Escape') {
      dismissedFor = input.value.trim().toLowerCase();
      closeSuggestions();
      return;
    }
    if (event.key !== 'Enter') return;

    event.preventDefault();
    clearTimeout(debounce);
    clearTimeout(suggestDebounce);

    if (open && active > -1) {
      pickSuggestion(suggestions[active]);
      return;
    }

    closeSuggestions();
    runAddressSearch(input.value);
  });

  // ...but nobody should have to KNOW to press Enter. Typing "perth" matches no store *name*, so
  // the free filter correctly empties the list and says "No stores found" — which is what a
  // shopper sees while the map is perfectly capable of showing them three Perth stores. Rom hit
  // exactly this, 2026-08-10.
  //
  // So a search that finds no store by name automatically becomes a place search. Gated three
  // ways so this cannot turn into a stream of billable calls: only when the name filter found
  // NOTHING (a real store-name search never geocodes), only past 3 characters, and debounced so
  // a word is one call rather than one per keystroke. Repeats of the same query are served from
  // lastQuery without touching the network at all.
  // Bound to BOTH keyup and input on purpose.
  //
  // The theme's own filter listens only to keyup, which misses every way of entering text that
  // does not involve the keyboard: pasting with the mouse, browser address autofill, and speech
  // input all fire `input` and never `keyup`. A full street address — the exact case Rom hit — is
  // far more often pasted or autofilled than typed out. `handleSearchInput` is idempotent for a
  // given value, so the two events firing together for one keystroke costs nothing.
  const handleSearchInput = (event) => {
    // THE SEARCH BOX DOES NOT FILTER. Rom, 2026-08-10: "it shouldn't be a filter or something,
    // what we need is when the textfield was used, it will just sort all the stores from nearest
    // to farthest from the location, so it will always render all the stores not filter it".
    //
    // Text matching against store names and addresses was actively misleading here. "brisbane"
    // matched exactly ONE store — Biggera Waters, because its address is 211 Brisbane Road — and
    // hid the three actually near Brisbane. "perth" matched none at all and produced "No stores
    // found" while three sat a few km away. Neither answer is one a store network should give.
    //
    // The theme's own keyup listener runs first and has already hidden cards by this point, so
    // this undoes it on every keystroke. Unconditionally: there is no case where narrowing the
    // list by string match beats ranking every store by distance.
    revealAllStores(infoWindows);

    // Enter is handled on keydown, which has already kicked off the search. Bail out AFTER the
    // reveal above, never before it.
    //
    // This ordering was the bug behind every "No stores found" report: pressing Enter fires a
    // keyup too, the theme's own filter runs on that keyup and hides all 52 cards, and returning
    // early here meant nothing put them back. The map moved correctly from the keydown search
    // while the list sat there claiming nothing existed — which is exactly what Rom kept seeing,
    // and why nudging the map "fixed" it (the map re-sort reveals everything).
    if (event && event.key === 'Enter') return;

    const query = input.value.trim();

    requestSuggestions(query);

    // Below 3 characters there is nothing worth resolving, and the full list is already back.
    if (query.length < 3) {
      clearTimeout(debounce);
      setSearchStatus(false);
      return;
    }

    // keyup and input both fire for one typed character. The second event must leave the timer
    // the first one armed alone — cancelling it here is what stopped typed searches resolving at
    // all, and left the status line on forever.
    if (query === lastHandled) return;
    lastHandled = query;

    // Shown immediately, covering the debounce AND the round-trip — the whole span in which the
    // shopper is waiting, not just the part where a request is open.
    clearTimeout(debounce);
    setSearchStatus(true);
    debounce = setTimeout(() => runAddressSearch(query), 600);
  };

  input.addEventListener('keyup', handleSearchInput);
  input.addEventListener('input', handleSearchInput);
};

/**
 * DG CUSTOM (#45): re-ranks the list against wherever the shopper has panned or zoomed the map.
 *
 * Costs NOTHING — the map already knows its own centre and every store's coordinates are already
 * in the page, so this is Haversine over 52 points. No geocode, no Places call, no request at all.
 * That makes browsing the map a free alternative to typing an address.
 *
 * Bound to `dragend` and `idle` rather than `center_changed`, which fires continuously during a
 * drag and would re-sort the DOM on every animation frame.
 *
 * `suppressResort` exists because we move the map ourselves — on geolocation and after an address
 * search. Without it, centring on the nearest store would immediately re-measure every distance
 * FROM that store, so a shopper who searched their own address would see "0.0 km away" against
 * the shop rather than the distance from home.
 * @param {object} map - The Google map instance.
 * @param {NodeList} infoWindows - All store cards.
 * @param {Element} mapElement - The map container, which carries the marker JSON.
 * @param {object} mapState - Shared `{ suppressResort }` flag owned by the caller.
 */
const initMapResort = (map, infoWindows, mapElement, mapState) => {
  if (!map || !mapElement || !window.DGStoreLocate) return;

  let markersJson = [];

  try {
    markersJson = JSON.parse(mapElement.dataset.markers || '[]');
  } catch (e) {
    return;
  }

  const resortToMapCentre = () => {
    if (mapState.suppressResort) return;

    const centre = map.getCenter();
    if (!centre) return;

    const ranked = DGStoreLocate.byDistance(
      markersJson,
      { lat: centre.lat(), lng: centre.lng() },
      (store) => store.coordinates
    );

    if (!ranked.length) return;

    revealAllStores(infoWindows);
    sortInfoWindowsByDistance(ranked, infoWindows);
  };

  map.addListener('dragend', resortToMapCentre);

  // Zoom settles into an `idle`. Guarded by the same flag, and by `hasSettled` so the map's very
  // first idle — before the shopper has touched anything — does not rank every store against
  // whatever start position the merchant configured.
  let hasSettled = false;
  map.addListener('idle', () => {
    if (!hasSettled) { hasSettled = true; return; }
    resortToMapCentre();
  });
};

const initStoreLocator = () => {
  const mapElement = document.querySelector(selectors.map);
  const infoWindows = document.querySelectorAll(selectors.infoWindows);
  let markers = [];
  let map = initMap(mapElement, markers);

  // Shared so the two places that move the map programmatically can mute the re-sort that a
  // move would otherwise trigger. An object, not a bare boolean, so it is genuinely shared.
  const mapState = { suppressResort: false };

  initFilters(map, infoWindows, markers);
  initMapResort(map, infoWindows, mapElement, mapState);
  initNearestStore(map, infoWindows, markers, mapElement, mapState);
  initAddressSearch(map, infoWindows, markers, mapElement, mapState);
};

document.addEventListener('DOMContentLoaded', () => {
  initStoreLocator();
});

